<template>
  <div class="has-text-left">
    <div class="paragraph">
      <prismic-rich-text
        :class="`mist-${language}-p mist-p`"
        :field="content.primary.info"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["content"],
  mounted() {
    console.log(this.content);
  },
  computed: {
    language() {
      return this.$store.getters["language/language"];
    },
  },
};
</script>

<style scoped>
.paragraph {
  padding: 30px 0 125px;
}
@media (max-width: 768px) {
  .paragraph {
    padding: 16px 0 32px;
  }
}
</style>